<template>
	<div class="signle-wrapper">
		<top :pagetitle="$t('注册')"></top>
		<div class="signle-main">
			<div class="form-panel">
				<div class="form-in">
					<div class="form-logo"><img :src="$helper.get('rule').app_logo" alt="" /></div>
					<!-- Nav tabs -->
					<div class="el-skin-tabs">
						<el-form ref="form" :model="form">
							<el-form-item>
								<el-input v-model="form.user_name" :placeholder="$t('请输入用户名')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.account" :type="this.account_rule == '1' ? 'text' : 'number'" :placeholder="this.account_rule == '1' ? $t('请输入邮箱') : $t('请输入手机号码')"></el-input>
							</el-form-item>
							<el-form-item v-if="front_image_validate_close == '1'">
								<div class="input-row flex">
									<div class="flex-col">
										<el-input v-model="form.code" type="number" :placeholder="$t('请输入短信验证码')"></el-input>
									</div>
									<el-button class="btn-getCode" type="warning"
										@click="account_type == '1' ? sendEmailCode() : sendPhoneCode()">
										{{ $t(sendCodeText) }}
									</el-button>
								</div>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.password" type="password" show-password :placeholder="$t('请输入密码')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.repassword" type="password" show-password :placeholder="$t('请输入确认密码')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.paypwd" type="password" show-password :placeholder="$t('请输入支付密码')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-input v-model="form.invite" type="number" :placeholder="$t('请输入邀请码')"></el-input>
							</el-form-item>
							<el-form-item>
								<el-checkbox v-model="form.checked">
									{{$t('勾选同意')}}
								</el-checkbox>
								<router-link v-if="signleNavs.length > 0" class="text-default" :to="'/explain?pageid=' + signleNavs[0].id">《{{$t('用户服务协议')}}》</router-link>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" round @click="onSubmit">
									{{$t('注册')}}
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="form-links text-center">
						<router-link to="/login" class="link-item">
							{{$t('已有账号，立即登录')}}
						</router-link>
					</div>
					<!-- <div class="form-share">
						<a href="" class="form-share-link">
							<span class="iconfont icon-facebook"></span>
						</a>
						<a href="" class="form-share-link">
							<span class="iconfont icon-telegram"></span>
						</a>
						<a href="" class="form-share-link">
							<span class="iconfont icon-insgram"></span>
						</a>
					</div> -->
				</div>
			</div>
		</div>
		<bottom></bottom>
	</div>
</template>
<script>
	import top from '@/components/top';
	import bottom from '@/components/bottom';
	import {index_notice_list_api} from '@/api/index'
	import {login_doReg_api,send_email_code_api,
		send_phone_code_api,} from '@/api/login'
	export default {
		components:{
			bottom,top
		},
		data() {
			return {
				spRules:{},
				activeName: 'first',
				account_rule:0,
				front_image_validate_close:0,
				invite_code_required:0,
				form: {
					user_name: '',
					account: '',
					invite: '',
					password: '',
					repassword: '',
					paypwd:'',
					code:'',
					checked: false,
				},
				signleNavs:[],
				sendCodeing: false,
				sendCodeLoading: false,
				sendCodeText: '发送',
				sendCodeSec: 60,
				account_type: '0',
			};
		},
		methods: {
			async sendPhoneCode() {
				let _this = this;
				if (_this.sendCodeing) {
					return
				}
				if (this.form.account == "") {
					this.errorTips("请输入手机号");
					return;
				}
				const phoneReg = /^(0\d{9}|\d{9})$/;
				if (!phoneReg.test(this.form.account)) {
					this.errorTips('请输入正确的手机格式');
					return;
				}
				_this.sendCodeLoading = true;
				await send_phone_code_api({
					phone: this.form.account,
					type: 1
				}).then(res => {
					_this.sendCodeLoading = false;
					if (res && res.data.code == 1) {
						this.countdown()
						this.successTips(res.data.msg);
					} else {
						this.errorTips(res.data.msg);
					}
				});
			},
			countdown() {
				this.sendCodeing = true;
				this.sendCodeText = this.sendCodeSec + "s";
				let clock = window.setInterval(() => {
					this.sendCodeSec--;
					this.sendCodeText = this.sendCodeSec + "s";
					if (this.sendCodeSec < 0) {
						window.clearInterval(clock);
						this.sendCodeText = this.$t("重新发送");
						this.sendCodeSec = 60;
						this.sendCodeing = false;
					}
				}, 1000);
			},
			async onSubmit() {
				if (this.form.user_name == "") {
					this.errorTips('请输入用户名');
					return false;
				}
				if (this.form.account == "") {
					this.errorTips(this.account_rule == 1 ? '请输入电子邮箱' : '请输入手机号码');
					return false;
				}
				const phoneReg = /^(0\d{9}|\d{9})$/;
				if (!phoneReg.test(this.form.account) && this.account_rule != 1) {
					this.errorTips('请输入正确的手机格式');
					return;
				}
				
				if (this.form.code == "" && this.front_image_validate_close == '1') {
					this.errorTips('请输入验证码');
					return false;
				}
				if (this.form.password == "") {
					this.errorTips('请输入密码');
					return false;
				}
				if (this.form.repassword == "") {
					this.errorTips('请输入确认密码');
					return false;
				}
				if (this.form.paypwd == "") {
					this.errorTips('请输入支付密码');
					return false;
				}
				if (this.form.invite == "" && this.invite_code_required == '1') {
					this.errorTips('请输入邀请码');
					return false;
				}
				if (!this.form.checked) {
					this.errorTips('请勾选协议')
					return false;
				}
				let param = {
					user_name: this.form.user_name,
					account: this.form.account,
					password: this.form.password,
					repassword: this.form.repassword,
					paypwd: this.form.paypwd,
					code: this.form.code,
					invite: this.form.invite,
				};
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				await login_doReg_api(param).then(res => {
					if (res && res.data.code == 1) {
						loading.close()
						console.log(res.data)
						this.$helper.set("tokenInfo", res.data.data);
						this.$store.commit("$vuexSetUserTokenState", res.data.data.token);
						this.$store.commit("$vuexSetUserTokenKeyState", res.data.data.token_key);
						this.updateUserInfo();
						this.$store.commit("$vuexSetLoginState", true);
						this.successTips('注册成功', {
							showClose: false,
							duration: "1000",
							onClose: () => {
								this.goUrl('/')
							}
						});
					} else {
						loading.close()
						this.errorTips(res.data.msg, {
							showClose: false,
							duration: "2000",
						});
					}
				});
			},
			async getNotice(typeid) {
				let param = {};
				const res = await index_notice_list_api(param);
				if (res && res.data.code == 1) {
					this.signleNavs = res.data.data.filter(item => item.is_nav === 6);
				}
			}
		},
		mounted() {
			this.getNotice();
			this.spRules = this.$helper.get('rule');
			this.account_rule = this.spRules.account_rule
			this.front_image_validate_close = this.spRules.front_image_validate_close
			this.invite_code_required = this.spRules.invite_code_required
		}
	}
</script>
<style scoped>
	@import url("../assets/css/signle.css");

	.form-links {
		justify-content: center;
	}
</style>